/**
 *  PRODUCT JS
 *  Get/add/delete/modify
 */

import ProductModal from './components/product/ProductModal';
import Vue from 'vue';

Vue.component('product-modal', ProductModal);

$(document).ready(function () {
    function trans(translation) {
        let language = document.documentElement.lang;

        return _.get(window.i18n, language + "." + translation);
    }
    if (document.getElementById('product_hidden')) {
        /* create product */
        //var modal = document.getElementById("myModal");
        let modal = document.getElementById("productModal");
        let btn = document.getElementById("popupCreateProduct");
        let span = document.getElementsByClassName("close")[0];
        let productModal = document.getElementById("productModal");

        btn.onclick = function () {
            vue.$refs["product-modal"].loadProduct(-1);
            modal.style.display = "block";
        };
        span.onclick = function () {
            modal.style.display = "none";
        };
        window.onclick = function (event) {
            if (event.target == productModal) {
                productModal.style.display = "none";
            }
            if(event.target == modal){
                modal.style.display = "none";
            }
        };
        $('#product_create_btn').on('click', function () {
            if (confirm(trans('page.product.view.add_product_q'))) {
                $.ajax({
                    url: '/article/add',
                    type: "post",
                    dataType: "json",
                    data: {
                        sku: $('#product_sku').val(),
                        alt_sku: $('#product_alt_sku').val(),
                        ean: $('#product_ean').val(),
                        name: $('#product_name').val(),
                        manufacturer: $('#product_manufacturer').val(),
                        comanufacturer: $('#product_comanufacturer').val(),
                        commodity_code: $('#product_commodityCode').val(),
                        weight: $('#product_weight').val(),
                        width: $('#product_width').val(),
                        height: $('#product_height').val(),
                        length: $('#product_length').val(),
                        status: $('#product_status').val(),
                        price_gros: $('#product_price_gros').val(),
                        price_net: $('#product_price_net').val(),
                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        alert(trans('page.product.view.product_was_created'));
                        location.reload();

                    },
                    error: function () {
                        let message = exception.responseJSON.message;

                        Object.keys(exception.responseJSON.errors).forEach(function (key) {
                            message += "\n" + exception.responseJSON.errors[key];
                        });

                        alert(message);
                    }
                });
            } else {
            }
        });

        $('.product_update_btn').on('click', function (evt) {
            if (confirm(trans('page.product.view.edit_product_q'))) {
                vue.$refs["product-modal"].loadProduct(this.dataset.productId);
                productModal.style.display = "block";
            } else {
            }
        });
        $('.product_delete_btn').on('click', function () {
            if (confirm(trans('page.product.view.delete_product_q'))) {
                let split = this.id.split("_", 2);
                $.ajax({
                    url: '/article/delete/' + split[1],
                    type: "post",
                    dataType: "json",
                    data: {},
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        alert(trans('page.product.view.product_was_deleted'));
                        location.reload();
                    },
                    error: function () {
                    }
                });
            } else {
            }
        });
    }
});